import React, { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import { personName } from './callFormat';
import StudentSearch from './StudentSearch';

const label = (s) => `${personName(s)}${s.consultation_number ? ` · #${s.consultation_number}` : ''}`;

/**
 * "Also file under": the other students a call is (or will be) filed under besides its primary
 * student — a parent with two children in Universe, typically. Each gets a copy of the call memo.
 *   primary      the call's student (never offered here)
 *   selected     the extra students now: [{ uuid, first_name, last_name, consultation_number }]
 *   suggestions  students the phone lookup found for the dialed number (siblings)
 *   onChange     called with the full new list
 *   allowSearch  offer a student search for a child whose number on file is different
 */
const AlsoFileUnder = ({ primary, selected = [], suggestions = [], onChange, allowSearch = false, disabled = false }) => {
    const [searching, setSearching] = useState(false);
    const taken = new Set([primary?.uuid, ...selected.map((s) => s.uuid)].filter(Boolean));
    const options = suggestions.filter((s) => s.uuid && !taken.has(s.uuid));
    if (!selected.length && !options.length && !allowSearch) return null;

    const add = (s) => { if (s?.uuid && !taken.has(s.uuid)) onChange([...selected, s]); };
    const remove = (s) => onChange(selected.filter((x) => x.uuid !== s.uuid));

    return (
        <Box sx={{ mb: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>Also file under</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                {selected.map((s) => (
                    <Chip key={s.uuid} size="small" color="primary" label={label(s)} onDelete={disabled ? undefined : () => remove(s)} />
                ))}
                {options.map((s) => (
                    <Chip key={s.uuid} size="small" variant="outlined" icon={<AddIcon />} label={label(s)} onClick={disabled ? undefined : () => add(s)} disabled={disabled} />
                ))}
                {allowSearch && !disabled && !searching && (
                    <Chip size="small" variant="outlined" icon={<PersonSearchOutlinedIcon />} label="Another student…" onClick={() => setSearching(true)} />
                )}
            </Box>
            {searching && (
                <Box sx={{ mt: 0.5 }}>
                    <StudentSearch
                        mode="attach"
                        pickLabel="Add"
                        autoFocus
                        placeholder="Student name or consultation #"
                        onPick={({ student }) => { add(student); setSearching(false); }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default AlsoFileUnder;
